import { useTranslation } from 'react-i18next'

import { Box, Button, Stack } from '@mui/material'

import { Carousel } from '@pages/LandingPage/components/Carousel'

import { TLGTypography } from '@components/TLGTypography'

import { carouselItemSx, containerSx, itemImageSx } from './styles'

export interface ICarouselItem {
  image: {
    name: string
    src: string
  }
  link?: string
}

const SIZE_OF_ITEMS_PER_WINDOW_BREAKPOINT_IN_PX = {
  xs: 130,
  md: 155,
  lg: 180,
  xl: 190,
  xxl: 190,
}

const IT_CUSTOMERS_CAROUSEL_ITEMS: ICarouselItem[] = [
  {
    image: {
      name: 'Ford',
      src: '/images/landing-pages/it-customer/ford.webp',
    },
  },
  {
    image: {
      name: 'Verizon',
      src: '/images/landing-pages/it-customer/verizon.webp',
    },
  },
  {
    image: {
      name: 'Samsung',
      src: '/images/landing-pages/it-customer/samsung.webp',
    },
  },
  {
    image: {
      name: 'Boise Cascade',
      src: '/images/landing-pages/it-customer/boise-cascade.webp',
    },
  },
  {
    image: {
      name: 'Disney',
      src: '/images/landing-pages/it-customer/disney.webp',
    },
  },
  {
    image: {
      name: 'Mercedes-Benz',
      src: '/images/landing-pages/it-customer/mercedes-benz.webp',
    },
  },
  {
    image: {
      name: 'Lockheed Martin',
      src: '/images/landing-pages/it-customer/lockheed-martin.webp',
    },
  },
  {
    image: {
      name: 'Johnson & Johnson',
      src: '/images/landing-pages/it-customer/johnson-johnson.webp',
    },
  },
  {
    image: {
      name: 'CVS Pharmacy',
      src: '/images/landing-pages/it-customer/cvs-pharmacy.webp',
    },
  },
  {
    image: {
      name: 'FedEx',
      src: '/images/landing-pages/it-customer/fedex.webp',
    },
  },
  {
    image: {
      name: 'Humana',
      src: '/images/landing-pages/it-customer/humana.webp',
    },
  },
  {
    image: {
      name: 'United Healthcare',
      src: '/images/landing-pages/it-customer/united-healthcare.webp',
    },
  },
]

const OurItCustomersSection = () => {
  const { t } = useTranslation()

  return (
    <Stack data-testid="home-our-it-customers-section" sx={containerSx}>
      <TLGTypography responsiveVariant={{ xs: 'subtitle1', md: 'h6' }}>
        {t('Some of our Tech Customers')}:
      </TLGTypography>

      <Carousel
        id="it-customers"
        dontCenterWhenFewerItems
        numberOfItemsPerPage={{
          dynamic: true,
          size: SIZE_OF_ITEMS_PER_WINDOW_BREAKPOINT_IN_PX,
        }}
        items={IT_CUSTOMERS_CAROUSEL_ITEMS}
        renderItem={({ image, link }, key) => (
          <Button
            key={key}
            data-testid="carousel-item"
            component="a"
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            sx={carouselItemSx({
              pointerCursor: !!link,
              addPadding: true,
            })}
          >
            <Box
              alt={image.name}
              title={image.name}
              loading="lazy"
              component="img"
              src={image.src}
              sx={itemImageSx}
            />
          </Button>
        )}
      />
    </Stack>
  )
}

export { OurItCustomersSection }
